const getActualId = ({ id, idBase }: { id?: string; idBase?: string }) =>
  id || (idBase ? idBase.toLowerCase().replace(/\s+/g, '-') : undefined)

export { getActualId }
